import { useContext, useState } from "react"

// Context
import { UserContext } from "../../../context/userContext"

//Formik
import { useField } from "formik"

//primeReact
import { Dropdown } from "primereact/dropdown"
import { Chips } from "primereact/chips"
import { MultiSelect } from "primereact/multiselect"

//styles
import styles from "../../../styles/Form-Inputs.module.css"
import taskCreateStyles from "../../../styles/tasks/TasksFormCreate.module.css"

export default function TaskCreateFormAssignInput({
  task,
  getUser,
  users,
  userOptions,
}) {
  const userCtx = useContext(UserContext)
  const [userTypeFilter, setUserTypeFilter] = useState("Staff")

  const [assignedUsers, meta, assignedUsersHelper] =
    useField("assignedToUserIds")

  const selectedUsers = assignedUsers.value.filter((user) =>
    !!user ? user.userRole === userTypeFilter : false
  )

  const customChipAssignedUser = (user) => {
    return (
      <div>{`${!!user?.optionName ? user.optionName : "Unknown user"} [${
        user?.userRole
      }]`}</div>
    )
  }

  function getUserOptions() {
    const options = userOptions.filter(
      (option) => option.name === userTypeFilter
    )
    if (options.length > 0) {
      return options[0].items.filter(
        (usr) =>
          usr.userRole !== "Participants" ||
          usr.status !== "Inactive Discharged"
      )
    } else {
      return []
    }
  }

  return (
    <div style={{ marginBottom: 10 }}>
      <div
        className={`${taskCreateStyles.description} ${taskCreateStyles.descriptionAssignUsers}`}
      >
        Assigned to
      </div>
      <div>
        {meta.touched && meta.error ? (
          <label id={`assignedToUserId-error`} className={styles.errFieldMsg}>
            {meta.error}
          </label>
        ) : null}
      </div>
      <div className={taskCreateStyles.allocated}>
        <Chips
          style={{ width: "485px" }} //Note: Hardcoded to override hardcoded size in global.css for .p-chips .p-chips-multiple-container, should actually be 100%
          value={assignedUsers.value}
          itemTemplate={customChipAssignedUser}
          onChange={(e) =>
            assignedUsersHelper.setValue(
              e.value.filter((user) => typeof user !== "string")
            )
          }
        />
      </div>
      <div className={taskCreateStyles.description} style={{ marginBottom: 4 }}>
        Assign users
        <button
          type="button"
          className="btn"
          style={{
            float: "right",
            height: 23,
            padding: "0px 9px",
            fontWeight: "normal",
          }}
          onClick={() => {
            const usrObj = getUser(userCtx.session.user.staff_id)

            if (!!usrObj) {
              if (!!task.id) {
                assignedUsersHelper.setValue([usrObj])
              } else {
                if (!assignedUsers.value.some((usr) => usr.id === usrObj.id)) {
                  assignedUsersHelper.setValue([...assignedUsers.value, usrObj])
                }
              }
            } else {
              userCtx.setNotificationError("Unable to find user profile")
            }
          }}
          disabled={!users}
        >
          Assign to me
        </button>
      </div>
      <div>
        <Dropdown
          style={{ width: "100%", marginBottom: "5px" }}
          options={["Staff", "Participants"]}
          placeholder="Select a user type"
          value={userTypeFilter}
          onChange={(value) => {
            setUserTypeFilter(value.value)
          }}
          disabled={!users}
        />
        {!!task.id ? (
          <Dropdown
            style={{ width: "100%" }}
            placeholder="Select a user"
            options={getUserOptions()}
            value={selectedUsers.length > 0 ? selectedUsers[0] : undefined}
            optionLabel="optionName"
            onChange={(value) => {
              assignedUsersHelper.setValue([value.value])
            }}
          />
        ) : (
          <MultiSelect
            style={{ width: "100%" }}
            placeholder="Select a user"
            options={getUserOptions()}
            value={selectedUsers}
            optionLabel="optionName"
            display="chip"
            maxSelectedLabels={2}
            onChange={(value) => {
              if (!!task.id) {
                assignedUsersHelper.setValue(value.value)
              } else {
                //Remove all users of the selected type that might be allocated
                let currentValues = assignedUsers.value.filter(
                  (remove) => remove.userRole !== userTypeFilter
                )
                //Add the list of allocated users for the selected type
                currentValues = [...currentValues, ...value.value]
                assignedUsersHelper.setValue(currentValues)
              }
            }}
          />
        )}
      </div>
    </div>
  )
}
